import { render, staticRenderFns } from "./MenuEditorHelpBlock.vue?vue&type=template&id=de3b9f2e"
import script from "./MenuEditorHelpBlock.vue?vue&type=script&lang=js"
export * from "./MenuEditorHelpBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports